export const HelperTextRElement = ({ helperText }: { helperText?: string }) =>
  helperText ? <p className="text-sm font-normal text-red-600">{helperText}</p> : null;
